<template>
  <div>
    <b-container class="home-container container-xl vali-hollow-logo text-left">
      <b-row class="mb-3 mb-md-5">
        <b-col sm="12" md="8 mb-4">
          <h1 class="green-text mb-4">Képzések</h1>
          <p class="text-medium font-weight-bold">
            2020-ban megújult a szakképzés és a felnőttképzés rendszere. Mik a legfontosabb újítások? Mi váltotta fel a
            korábbi OKJ-t? Hogy alakult át a vizsgarendszer? A legfontosabb tudnivalók a megújult képzési rendszerről.
          </p>
        </b-col>
        <b-col sm="12" md="10">
          <p class="text-small mb-0">
            A gazdaságban és a munkaerőpiacon gyorsuló ütemben zajló technológiai változások, azaz az Ipar 4.0 és a
            digitalizáció ráirányították a figyelmet a munkaerőpiac elvárásait gyorsan lekövetni képes képzési rendszer
            iránti gazdasági igényre. Ezt felismerve 2019-ben döntött a Kormány – a szakképzési rendszer mellett – a
            felnőttképzési rendszer több lépcsőben történő megújításáról.
          </p>
          <p class="text-small margin-bottom--2rem">
            Az átalakítási folyamat részeként módosultak többek között a felnőttképzési jogszabályok, valamint megjelent
            a felnőttképzés adatszolgáltatási rendszere (FAR) is.
          </p>
          <p class="text-small mb-0">
            Annak érdekében, hogy a vállalkozások hiteles forrásból, közérthető és átlátható módon tudják áttekinteni a
            felnőttképzési rendszer legfontosabb újításait, kidolgoztunk egy digitális útmutatót, amely regisztrációt
            követően:
          </p>
          <ul class="text-small margin-bottom--2rem">
            <li>segít eligazodni a jogszabályokban bekövetkezett változásokban és azok helyes alkalmazásában</li>
            <li>végigvezeti az érdeklődőket az új adatszolgáltatási rendszer folyamatain</li>
            <li>tájékoztatást nyújt az új vizsgáztatási rendszer működéséről</li>
            <li>
              tartalmaz egy „gyakori kérdések és válaszok” gyűjteményt, ahol az érdeklődők célzottan is megkereshetik az
              őket érintő válaszokat.
            </li>
          </ul>
        </b-col>
        <b-col sm="12" md="3">
          <b-button
            class="button-course"
            href="https://home.nexiuslearning.com/campaign/launch/?campaignId=74553d4d-0652-4282-a469-6bca8e17e725&locale=hu-HU"
            target="_blank"
          >
            Tudjon meg többet
          </b-button>
        </b-col>
      </b-row>
      <b-row class="pt-4">
        <b-col sm="12" md="8" class="mb-0 mb-md-4">
          <p class="text-medium">
            Milyen szakmákra képezhetem a munkavállalóimat?
          </p>
        </b-col>
      </b-row>
      <b-row class="mb-3 mb-md-5">
        <b-col sm="12" md="6">
          <a class="profession-wrapper" href="https://szakkepzes.ikk.hu/szakmakartyak/szakmak" target="_blank">
            <div class="p-4">
              <p class="mb-0">A 177 alapszakma listája</p>
            </div>
            <div class="pr-5">
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M12 0L9.885 2.115L18.255 10.5H0V13.5H18.255L9.885 21.885L12 24L24 12L12 0Z" fill="#00903C" />
              </svg>
            </div>
          </a>
        </b-col>
        <b-col sm="12" md="6">
          <a class="profession-wrapper" href="https://szakkepesites.ikk.hu/" target="_blank">
            <div class="p-4">
              <p class="mb-0">A szakmai képzések listája</p>
            </div>
            <div class="pr-5">
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M12 0L9.885 2.115L18.255 10.5H0V13.5H18.255L9.885 21.885L12 24L24 12L12 0Z" fill="#00903C" />
              </svg>
            </div>
          </a>
        </b-col>
      </b-row>
      <b-row class="margin-bottom--1rem">
        <b-col sm="12" md="8" class="mb-0 mb-md-4">
          <p class="text-medium">
            Milyen képzések indulnak a közeljövőben?
          </p>
        </b-col>
        <b-col sm="12" md="10">
          <p class="text-small">
            Válasszon képzést hiteles forrásból. Böngéssze a közeljövőben induló képzések listáját az alábbi gombra
            kattintva.
          </p>
        </b-col>
      </b-row>
      <b-row class="mb-4 mb-md-5">
        <b-col sm="12" md="3">
          <b-button
            class="button-course"
            href="https://far.nive.hu/publikus-adatok/meghirdetett-kepzesek"
            target="_blank"
          >
            Induló képzések listája
          </b-button>
        </b-col>
      </b-row>
      <b-row class="pt-3 mb-3 mb-md-4">
        <b-col sm="12" md="8" class="mb-0 mb-md-3">
          <p class="text-medium">
            Kiktől vehetek igénybe képzést?
          </p>
        </b-col>
        <b-col sm="12" md="10">
          <p class="text-small">
            Az engedéllyel rendelkező, minősített, valamint a bejelentéssel rendelkező felnőttképző intézmények listája
            az alábbi linken érhető el. A támogatási programokban engedéllyel rendelkező felnőttképző szolgáltatók
            vehetők igénybe.
          </p>
        </b-col>
      </b-row>
      <b-row class="mb-4 mb-md-5">
        <b-col sm="12" md="3">
          <b-button
            class="button-course"
            href="https://far.nive.hu/publikus-adatok/felnottkepzok-nyilvantartasa"
            target="_blank"
          >
            Állami nyilvántartás
          </b-button>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
export default {
  name: 'Courses'
}
</script>

<style scoped>
.text-small {
  font-size: 13px;
  font-weight: 400;
  color: #2b2b2b;
}
.text-medium {
  font-size: 20px;
  color: #2b2b2b;
}

.margin-bottom--1rem {
  margin-bottom: 1rem;
}

.margin-bottom--2rem {
  margin-bottom: 2rem;
}

.button-course {
  background: #00903c;
  font-weight: 700;
  color: #fff;
  width: 100%;
  height: 44px;
  line-height: 29px;
  border-radius: 8px;
}

.profession-wrapper {
  display: flex;
  height: 100px;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  background: #f2f8fa;
  text-decoration: none;
  font-weight: 700;
  color: #00903c;
}

.login-container {
  border: 1px solid #00903c;
  padding-top: 20px;
  padding-bottom: 20px;
  border-radius: 15px;
}

.border {
  border-color: #00903c !important;
}

.home-container h2 {
  margin-bottom: 1.5rem;
}

.home-container {
  margin-top: 2rem;
}

.vali-logo {
  max-width: 200px;
  margin-left: -15px;
}

.vali-hollow-logo {
  position: relative;
  overflow: hidden;
}

.vali-hollow-logo:before {
  content: ' ';
  display: block;
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  z-index: 0;
  opacity: 0.2;
  background-image: url('../assets/img/logo/vekonyvali_hollow.svg');
  background-repeat: no-repeat;
  background-position: 100% 0;
  background-size: 70%;
}

.opacity-logo {
  width: 100%;
  max-width: 500px;
  margin: 0 auto;
  opacity: 0.6;
}

@media (max-width: 768px) {
  .profession-wrapper {
    margin-bottom: 1.5rem;
  }

  .home-container {
    margin-top: 0rem !important;
  }
}
</style>
